import Masonry from "masonry-layout";
import naja from "naja";
import {Ajax} from "../../components/ajax";

export default function(html) {
	html.querySelectorAll('.articles-loader').forEach((el) => {
		const grid = el.closest('.row').previousElementSibling
		el.querySelector('a').addEventListener('click', (e) => {
			e.preventDefault()
			const icon = e.currentTarget.querySelector('i.fas')
			icon.classList.remove('d-none')

			const start = parseInt(el.dataset.start)
			const end = parseInt(el.dataset.end)
			if (start >= 1 && end > 1 && start <= end) {
				const url = e.currentTarget.getAttribute('href')
				const pageNo = start + 1
				el.dataset.start = pageNo.toString()

				naja.makeRequest('GET', url, {pageNo: pageNo}, {history: false}).then((payload) => {
					if (pageNo >= end) {
						el.classList.add('d-none')
					}

					if (typeof grid.dataset.najaSnippetAppend === "undefined") {
						grid.innerHTML += payload.snippets['snippet--articles']
					}
					init(html)

					setTimeout(() => {
						icon.classList.add('d-none')
					}, 500)

				}).catch((err) => {
					icon.classList.add('d-none')
					alert(err)
				})
			}
		})
	})

	const ajax = new Ajax(document, false)
	ajax.onAfterUpdate((root) => {
		init(root)
	}).run(html)
}


function init(html) {
	html.querySelectorAll('.masonry-grid').forEach((grid) => {
		if (grid.querySelectorAll('.grid-item').length > 0) {
			let imagesCounter = grid.querySelectorAll('.article img:not(.loaded)').length

			if (imagesCounter > 0) {
				grid.querySelectorAll('.article img:not(.loaded)').forEach((img) => {
					const callback = (e) => {
						imagesCounter--
						e.currentTarget.classList.add('loaded')

						if (imagesCounter === 0) {
							initMasonry(grid)
						}
					}

					img.addEventListener('load', callback)
					img.addEventListener('error', callback)

					if (img.complete) {
						imagesCounter--
						img.classList.add('loaded')

						if (imagesCounter === 0) {
							initMasonry(grid)
						}
					}
				})
			} else {
				initMasonry(grid)
			}
		}
	})

	html.querySelectorAll('.read-more-toggler').forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault()

			const content = e.currentTarget.previousElementSibling
			if (content.classList.contains('content-more')) {
				content.classList.toggle('d-none')
				const text = e.currentTarget.textContent
				e.currentTarget.textContent = e.currentTarget.dataset.opposite
				e.currentTarget.dataset.opposite = text
			}
		})
	})

	html.querySelectorAll('.widget-four-tiles').forEach((el) => {
		let fourTiles = [];
		let max = 0;

		el.querySelectorAll('.tile-block a').forEach((a) => {
			let h = parseInt(window.getComputedStyle(a, null)?.getPropertyValue('height'))
			if(max < h) {
				max = h;
			}

			fourTiles.push({
				el: a,
				height: h
			});
		})

		for(let data of fourTiles) {
			data.el.style.height = max + 'px';

			let pt = max - data.height;
			if(pt > 0) {
				data.el.style.paddingTop = (parseInt(window.getComputedStyle(data.el, null)?.getPropertyValue('padding-top')) + pt / 2) + 'px'
			}
		}
	})
}


function initMasonry(el) {
	new Masonry(el, {
		itemSelector: '.grid-item',
		percentPosition: true,
		horizontalOrder: true
	})
}
